import { ProductsScreen } from './ProductsScreen.jsx';

export default {
  path: '/products',
  element: <ProductsScreen />,
  protected: true,
  permission: 'inventory.view',
  standalone: false,
  sidebar: { label: 'المنتجات والأقسام', icon: 'products', group: 'inventory', order: 72 }
};
